import {
  Box,
  Button,
  Container,
  CssBaseline,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../hooks/redux-hooks";
import { updateInfo, removeCustomerAddr } from "../slices/authSlice";
import {
  showNotification,
  NotificationType,
} from "../slices/notificationSlice";
import { useNavigate, Navigate } from "react-router-dom";
// import { Autocomplete } from "@mui/material";
import * as consts from "../constants";
import { parseAddress, assembleAddress } from "../utils/addressUtils";
import DeleteAccountDialog from "../components/DeleteAccountDialog";

const MyInfo = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const basicUserInfo = useAppSelector((state) => state.auth.basicUserInfo);

  useEffect(() => {
    if (basicUserInfo) {
      setName(basicUserInfo.name || "");
      setPhone(basicUserInfo.phone || "");

      // 解析地址
      const newAddresses = Array(5).fill({
        street: "",
        zipCode: "",
        city: "",
      });
      if (basicUserInfo.addr1) {
        const addr1Parts = parseAddress(basicUserInfo.addr1);
        // setAddr1Street(addr1Parts.street);
        // setAddr1ZipCode(addr1Parts.zipcode);
        // setAddr1City(addr1Parts.city);
        // //setAddr1State(addr1Parts.state);
        newAddresses[0] = {
          street: addr1Parts.street,
          zipCode: addr1Parts.zipcode,
          city: addr1Parts.city,
        };
      }

      if (basicUserInfo.addr2) {
        const addr2Parts = parseAddress(basicUserInfo.addr2);
        newAddresses[1] = {
          street: addr2Parts.street,
          zipCode: addr2Parts.zipcode,
          city: addr2Parts.city,
        };
      }

      if (basicUserInfo.addr3) {
        const addr3Parts = parseAddress(basicUserInfo.addr3);
        newAddresses[2] = {
          street: addr3Parts.street,
          zipCode: addr3Parts.zipcode,
          city: addr3Parts.city,
        };
      }

      if (basicUserInfo.addr4) {
        const addr4Parts = parseAddress(basicUserInfo.addr4);
        newAddresses[3] = {
          street: addr4Parts.street,
          zipCode: addr4Parts.zipcode,
          city: addr4Parts.city,
        };
      }

      if (basicUserInfo.addr5) {
        const addr5Parts = parseAddress(basicUserInfo.addr5);
        newAddresses[4] = {
          street: addr5Parts.street,
          zipCode: addr5Parts.zipcode,
          city: addr5Parts.city,
        };
      }
      // console.log(newAddresses);
      setAddresses(newAddresses);
    }
  }, [basicUserInfo]);

  const handleBack = async () => {
    navigate("/select");
  };

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");

  // const [addr1Street, setAddr1Street] = useState("");
  // const [addr1ZipCode, setAddr1ZipCode] = useState("");
  // const [addr1City, setAddr1City] = useState("");
  // //const [addr1State, setAddr1State] = useState("");
  // const [addr2Street, setAddr2Street] = useState("");
  // const [addr2ZipCode, setAddr2ZipCode] = useState("");
  // const [addr2City, setAddr2City] = useState("");
  // //const [addr2State, setAddr2State] = useState("");
  const [addresses, setAddresses] = useState(
    Array(5).fill({
      street: "",
      zipCode: "",
      city: "",
    })
  );
  const [addressErrors, setAddressErrors] = useState(
    Array(5).fill({
      streetError: "",
      zipCodeError: "",
      cityError: "",
    })
  );

  const [nameError, setNameError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [deleteAccountOpen, setDeleteAccountOpen] = useState(false);

  // const [addr1StreetError, setAddr1StreetError] = useState("");
  // const [addr1CityError, setAddr1CityError] = useState("");
  // //const [addr1StateError, setAddr1StateError] = useState("");
  // const [addr1ZipCodeError, setAddr1ZipCodeError] = useState("");
  // const [addr2StreetError, setAddr2StreetError] = useState("");
  // const [addr2CityError, setAddr2CityError] = useState("");
  // //const [addr2StateError, setAddr2StateError] = useState("");
  // const [addr2ZipCodeError, setAddr2ZipCodeError] = useState("");

  if (!basicUserInfo) {
    return <Navigate replace to={"/login"} />;
  }

  const handleUpdate = async () => {
    setNameError("");
    setPhoneError("");

    if (!name) {
      setNameError(t("errNameRequired"));
      return;
    }
    if (!phone) {
      setPhoneError(t("errPhoneRequired"));
      return;
    }

    if (!validateAddresses()) {
      return;
    }

    // const addr1 = assembleAddress({
    //   street: addr1Street,
    //   zipcode: addr1ZipCode,
    //   city: addr1City,
    //   state: consts.defaultState, //addr1State,
    // });

    // const addr2 = assembleAddress({
    //   street: addr2Street,
    //   zipcode: addr2ZipCode,
    //   city: addr2City,
    //   state: consts.defaultState, //addr2State,
    // });

    const data: any = {
      customer_id: +basicUserInfo.uid,
      name,
      phone,
    };
    // if (addr1) {
    //   data.addr1 = addr1;
    // }
    // if (addr2) {
    //   data.addr2 = addr2;
    // }
    // 处理地址
    addresses.forEach((address, index) => {
      if (address.street || address.city || address.zipCode) {
        const addr = assembleAddress({
          street: address.street,
          zipcode: address.zipCode,
          city: address.city,
          state: consts.defaultState,
        });
        if (addr) {
          data[`addr${index + 1}`] = addr;
        }
      }
    });

    try {
      await dispatch(updateInfo(data)).unwrap();
      dispatch(
        showNotification({
          message: t("userInfoUpdateSuccess"),
          type: NotificationType.Success,
        })
      );
      // navigate(-1);
    } catch (error: any) {
      dispatch(
        showNotification({
          message: error?.message || t("userInfoUpdateFailed"),
          type: NotificationType.Error,
        })
      );
    }
  };

  // 修改验证函数
  const validateAddresses = () => {
    const newErrors = Array(5).fill({
      streetError: "",
      zipCodeError: "",
      cityError: "",
    });
    let isValid = true;

    addresses.forEach((address, index) => {
      const hasStreet = !!address.street;
      const hasCity = !!address.city;
      const hasZipCode = !!address.zipCode;

      if (hasStreet || hasCity || hasZipCode) {
        const currentError = {
          streetError: "",
          zipCodeError: "",
          cityError: "",
        };

        if (!hasStreet) {
          currentError.streetError = t("errStreetRequired");
          isValid = false;
        }
        if (!hasCity) {
          currentError.cityError = t("errCityRequired");
          isValid = false;
        }
        if (!hasZipCode) {
          currentError.zipCodeError = t("errZipCodeRequired");
          isValid = false;
        }

        newErrors[index] = currentError;
      }
    });

    setAddressErrors(newErrors);
    return isValid;
  };

  const handleRemoveAddress = (index: number) => {
    if (basicUserInfo?.uid) {
      dispatch(removeCustomerAddr({
        customer_id: +basicUserInfo.uid,
        addr: index + 1
      }));

      // 同时更新本地状态
      const newAddresses = [...addresses];
      newAddresses[index] = {
        street: "",
        zipCode: "",
        city: "",
      };
      setAddresses(newAddresses);

      // 显示成功通知
      dispatch(
        showNotification({
          message: t("addrRemoveSuccess"),
          type: NotificationType.Success,
        })
      );
    }
  };

  // 验证地址1的必填字段
  // const validateAddr1 = () => {
  //   setAddr1StreetError("");
  //   setAddr1CityError("");
  //   //setAddr1StateError("");
  //   setAddr1ZipCodeError("");

  //   const hasStreet = !!addr1Street;
  //   const hasCity = !!addr1City;
  //   //const hasState = !!addr1State;
  //   const hasZipCode = !!addr1ZipCode;

  //   // 如果有任意一个字段填写，则其他字段都必须填写
  //   if (hasStreet || hasCity || hasZipCode) {//hasState) {
  //     if (!hasStreet) {
  //       setAddr1StreetError(t("errStreetRequired"));
  //     }
  //     if (!hasCity) {
  //       setAddr1CityError(t("errCityRequired"));
  //     }
  //     // if (!hasState) {
  //     //   setAddr1StateError(t("errStateRequired"));
  //     // }
  //     if (!hasZipCode) {
  //       setAddr1ZipCodeError(t("errZipCodeRequired"));
  //     }
  //     return hasStreet && hasCity && hasZipCode;//hasState;
  //   }
  //   return true; // 全部为空也是合法的
  // };

  // 验证地址2的必填字段
  // const validateAddr2 = () => {
  //   setAddr2StreetError("");
  //   setAddr2CityError("");
  //   // setAddr2StateError("");
  //   setAddr2ZipCodeError("");

  //   const hasStreet = !!addr2Street;
  //   const hasCity = !!addr2City;
  //   // const hasState = !!addr2State;
  //   const hasZipCode = !!addr2ZipCode;

  //   if (hasStreet || hasCity || hasZipCode) {//hasState) {
  //     if (!hasStreet) {
  //       setAddr2StreetError(t("errStreetRequired"));
  //     }
  //     if (!hasCity) {
  //       setAddr2CityError(t("errCityRequired"));
  //     }
  //     // if (!hasState) {
  //     //   setAddr2StateError(t("errStateRequired"));
  //     // }
  //     if (!hasZipCode) {
  //       setAddr2ZipCodeError(t("errZipCodeRequired"));
  //     }
  //     return hasStreet && hasCity && hasZipCode;//hasState;
  //   }
  //   return true;
  // };

  return (
    <>
      <Container maxWidth="sm">
        <CssBaseline />
        <Box
          sx={{
            //mt: 20,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography variant="h5">{t("selectMyInfo")}</Typography>
          <Box sx={{ mt: 3 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  name="name"
                  required
                  fullWidth
                  id="name"
                  label={t("name")}
                  autoFocus
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  error={!!nameError}
                  helperText={nameError}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  name="phone"
                  label={t("phone")}
                  value={phone}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (!value || /^\+?[0-9]{0,15}$/.test(value)) {
                      setPhone(value);
                    }
                  }}
                  error={
                    !!phoneError ||
                    (phone !== "" && !/^\+?[0-9]{10,15}$/.test(phone))
                  }
                  helperText={
                    phoneError ||
                    (phone !== "" && !/^\+?[0-9]{10,15}$/.test(phone)
                      ? t("errPhoneInvalid")
                      : "")
                  }
                  placeholder="+1234567890"
                />
              </Grid>
              {/* <Grid item xs={12}>
                <Typography variant="subtitle1" sx={{ mb: 1 }}>
                  {t("addr1")}
                </Typography>
                <Box sx={{ border: "1px solid #ccc", borderRadius: 1, p: 2 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        name="addr1_street"
                        label={t("streetAddress")}
                        value={addr1Street}
                        onChange={(e) => setAddr1Street(e.target.value)}
                        error={!!addr1StreetError}
                        helperText={addr1StreetError}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        name="addr1_city"
                        label={t("city")}
                        value={addr1City}
                        onChange={(e) => setAddr1City(e.target.value)}
                        error={!!addr1CityError}
                        helperText={addr1CityError}
                      />
                    </Grid>
                    <Grid item xs={6}>
                    <TextField
                        fullWidth
                        name="addr1_zipcode"
                        label={t("zipcode")}
                        value={addr1ZipCode}
                        onChange={(e) => {
                          // 只允许输入数字且长度为4-6位
                          const value = e.target.value.replace(/[^0-9]/g, '');
                          if (value.length <= 6) {
                            setAddr1ZipCode(value);
                          }
                        }}
                        error={!!addr1ZipCodeError || !!(addr1ZipCode && ![4, 5, 6].includes(addr1ZipCode.length))}
                        helperText={addr1ZipCodeError || (addr1ZipCode && ![4, 5, 6].includes(addr1ZipCode.length) ? t("errZipCodeInvalid") : "")}
                        inputProps={{
                          inputMode: 'numeric',
                          pattern: '[0-9]*'
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Autocomplete
                        options={consts.states}
                        value={
                          addr1State
                            ? consts.states.find((state) =>
                                state.startsWith(addr1State)
                              ) || null
                            : null
                        }
                        onChange={(_, newValue) => {
                          setAddr1State(
                            newValue ? newValue.split(" - ")[0] : ""
                          );
                        }}
                        getOptionLabel={(option) => option}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={t("selState")}
                            error={!!addr1StateError}
                            helperText={addr1StateError}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle1" sx={{ mb: 1 }}>
                  {t("addr2")}
                </Typography>
                <Box sx={{ border: "1px solid #ccc", borderRadius: 1, p: 2 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        name="addr2_street"
                        label={t("streetAddress")}
                        value={addr2Street}
                        onChange={(e) => setAddr2Street(e.target.value)}
                        error={!!addr2StreetError}
                        helperText={addr2StreetError}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        name="addr2_city"
                        label={t("city")}
                        value={addr2City}
                        onChange={(e) => setAddr2City(e.target.value)}
                        error={!!addr2CityError}
                        helperText={addr2CityError}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        name="addr2_zipcode"
                        label={t("zipcode")}
                        value={addr2ZipCode}
                        onChange={(e) => setAddr2ZipCode(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Autocomplete
                        options={consts.states}
                        value={
                          addr2State
                            ? consts.states.find((state) =>
                                state.startsWith(addr2State)
                              ) || null
                            : null
                        }
                        onChange={(_, newValue) => {
                          setAddr2State(
                            newValue ? newValue.split(" - ")[0] : ""
                          );
                        }}
                        getOptionLabel={(option) => option}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={t("selState")}
                            error={!!addr2StateError}
                            helperText={addr2StateError}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Grid> */}
              {/* 循环渲染地址字段 */}
              {addresses.map((address, index) => (
                <Grid item xs={12} key={index}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                    <Typography variant="subtitle1">
                      {t("addr")} {index + 1}
                    </Typography>
                    <Button
                      size="small"
                      color="error"
                      onClick={() => handleRemoveAddress(index)}
                    >
                      {t("btnDelete")}
                    </Button>
                  </Box>
                  <Box sx={{ border: "1px solid #ccc", borderRadius: 1, p: 2 }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          id={`addr${index + 1}_street`}
                          name={`addr${index + 1}_street`}
                          autoComplete={`address-line1 addr${index + 1}`}
                          label={t("streetAddress")}
                          value={address.street}
                          onChange={(e) => {
                            const newAddresses = [...addresses];
                            newAddresses[index] = {
                              ...address,
                              street: e.target.value,
                            };
                            setAddresses(newAddresses);
                          }}
                          error={!!addressErrors[index].streetError}
                          helperText={addressErrors[index].streetError}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          id={`addr${index + 1}_city`}
                          name={`addr${index + 1}_city`}
                          autoComplete={`address-city addr${index + 1}`}
                          label={t("city")}
                          value={address.city}
                          onChange={(e) => {
                            const newAddresses = [...addresses];
                            newAddresses[index] = {
                              ...address,
                              city: e.target.value,
                            };
                            setAddresses(newAddresses);
                          }}
                          error={!!addressErrors[index].cityError}
                          helperText={addressErrors[index].cityError}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          id={`addr${index + 1}_zipcode`}
                          name={`addr${index + 1}_zipcode`}
                          autoComplete={`postal-code addr${index + 1}`}
                          label={t("zipcode")}
                          value={address.zipCode}
                          onChange={(e) => {
                            const value = e.target.value.replace(/[^0-9]/g, "");
                            if (value.length <= 6) {
                              const newAddresses = [...addresses];
                              newAddresses[index] = {
                                ...address,
                                zipCode: value,
                              };
                              setAddresses(newAddresses);
                            }
                          }}
                          error={
                            !!addressErrors[index].zipCodeError ||
                            !!(
                              address.zipCode &&
                              ![4, 5, 6].includes(address.zipCode.length)
                            )
                          }
                          helperText={
                            addressErrors[index].zipCodeError ||
                            (address.zipCode &&
                            ![4, 5, 6].includes(address.zipCode.length)
                              ? t("errZipCodeInvalid")
                              : "")
                          }
                          inputProps={{
                            inputMode: "numeric",
                            pattern: "[0-9]*",
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              ))}
            </Grid>

            {!basicUserInfo.is_guest && <Button fullWidth variant="outlined" color="error"
              sx={{ mt: 3 }} onClick={() => setDeleteAccountOpen(true)}>
              {t("accountDeleteButton").toUpperCase()}
            </Button>}
            <Button
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              onClick={handleUpdate}
            >
              {t("btnUpdate")}
            </Button>
            <Button
              fullWidth
              variant="contained"
              //sx={{ mt: 3, mb: 2 }}
              onClick={handleBack}
            >
              {t("btnBack")}
            </Button>
          </Box>
        </Box>
      </Container>
      <DeleteAccountDialog open={deleteAccountOpen} onClose={() => setDeleteAccountOpen(false)} />
    </>
  );
};

export default MyInfo;
